module.exports = __webpack_public_path__ + "static/img/101002.b05b8b68.png";